var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computedFrom } from "aurelia-binding";
import { Guid } from "../../../utilities/guid";
import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import { ColorUtilities, Hsv } from "./color-utilities";
import { Reflection } from "../../../utilities/reflection";
var ColorPicker = /** @class */ (function () {
    function ColorPicker() {
        var _this = this;
        this.a = 255;
        this.isHex = ColorUtilities.isHex;
        this.identifier = Guid.generateGuid();
        this.label = "";
        this.format = "";
        this.color = "ffffff";
        this.onBlured = function () {
            if (_this.color && _this.format == "css") {
                var isValid = /^#[a-zA-Z0-9]{6}$/.test(_this.color);
                if (!isValid) {
                    _this.color = "";
                }
            }
            else {
                var isValid = /^[a-zA-Z0-9]{6}$/.test(_this.color);
                if (!isValid) {
                    _this.color = "";
                }
            }
        };
        this.openColorPalette = function () {
            _this.container.classList.remove("hidden");
            _this.setPostion();
            setTimeout(function () {
                _this.colorChanged(_this.color, null);
            });
            clearInterval(_this.intervalForPosition);
            _this.intervalForPosition = setInterval(function () {
                _this.setPostion();
            }, 100);
            _this.container.addEventListener('click', _this.stopPropagation);
            document.addEventListener('click', _this.closeColorPalette);
        };
        this.closeColorPalette = function () {
            if (_this.container) {
                _this.container.classList.add('hidden');
                _this.container.addEventListener('click', _this.stopPropagation);
                document.removeEventListener('click', _this.closeColorPalette);
                clearInterval(_this.intervalForPosition);
            }
        };
        document.addEventListener("mousedown", function (e) {
            var sourceElement = e.srcElement || e.target;
            if (_this.container && _this.container.contains(sourceElement)) {
                return;
            }
            if (_this.container) {
                _this.container.style.left = 0 + "px";
                _this.container.style.top = 0 + "px";
                _this.container.classList.add("hidden");
            }
        });
    }
    Object.defineProperty(ColorPicker.prototype, "hexColorFormat", {
        get: function () {
            var returnValue = this.color;
            switch (this.format) {
                case "css":
                    {
                        if (this.color && this.color.indexOf("#") === 0) {
                            returnValue = this.color.substr(1, this.color.length - 1);
                        }
                    }
                    break;
                default:
                    {
                        if (this.color && this.color.indexOf("#") === 0) {
                            returnValue = this.color.substr(1, this.color.length - 1);
                        }
                    }
                    break;
            }
            return returnValue;
        },
        enumerable: false,
        configurable: true
    });
    ColorPicker.prototype.formatColorString = function (value) {
        var returnValue = value;
        switch (this.format) {
            case "css":
                {
                    returnValue = "#" + value;
                }
                break;
        }
        return returnValue;
    };
    ColorPicker.prototype.getDimensions = function (element) {
        var result = { width: element.offsetWidth, height: element.offsetHeight, };
        return result;
    };
    ;
    ColorPicker.prototype.colorChanged = function (newValue, oldValue) {
        if (newValue && ColorUtilities.isValid(this.hexColorFormat) && this.canvas) {
            var rect = this.canvas.getBoundingClientRect();
            var rectContainer = this.colorPalette.getBoundingClientRect();
            var rectPointer = this.colorPointer.getBoundingClientRect();
            var offsetY = rect.top - rectContainer.top;
            var offsetX = rect.left - rectContainer.left;
            var width = this.canvas.offsetWidth;
            var height = this.canvas.offsetHeight;
            var x = rectPointer.left + this.getDimensions(this.colorPointer).width / 2 - rect.left + offsetX;
            var y = rectPointer.top + this.getDimensions(this.colorPointer).height / 2 - rect.top + offsetY;
            x = x <= offsetX ? offsetX : (x >= width ? width : x);
            y = y <= offsetY ? offsetY : (y >= height + offsetY ? height + offsetY : y);
            var col = new Hsv(this.hue, Math.round(x / this.canvas.offsetWidth * 100), Math.round(100 - (y - offsetY) / this.canvas.offsetHeight * 100));
            var b1w = ColorUtilities.hsv2rgb(col.$, col.s, col.v);
            var color = ColorUtilities.rgbToHex(b1w.r, b1w.g, b1w.b);
            if (this.hexColorFormat && color !== this.hexColorFormat) {
                var rgb = ColorUtilities.getRgbColor(this.hexColorFormat);
                var hsv = ColorUtilities.rgbToHsv(rgb.r, rgb.g, rgb.b);
                this.positionHueSlider = hsv.h;
                x = hsv.s * this.canvas.offsetWidth / 100;
                y = (100 - hsv.v) * this.canvas.offsetHeight / 100 + offsetY;
                this.colorPointer.style.left = x - this.getDimensions(this.colorPointer).width / 2 + "px";
                this.colorPointer.style.top = y - this.getDimensions(this.colorPointer).height / 2 + "px";
            }
        }
    };
    ColorPicker.prototype.setPostion = function () {
        if (this.input) {
            var inputRect = this.input.getBoundingClientRect();
            var containerRect = this.container.getBoundingClientRect();
            this.container.style.top = inputRect.bottom + containerRect.height > window.innerHeight ? (inputRect.top - containerRect.height) + "px" : inputRect.bottom + "px";
            var left = inputRect.left;
            if (left + containerRect.width > window.innerWidth) {
                left -= (left + containerRect.width - window.innerWidth);
            }
            this.container.style.left = left + "px";
        }
    };
    ColorPicker.prototype.stopPropagation = function ($event) {
        $event.stopPropagation();
    };
    ColorPicker.prototype.attached = function () {
        var _this = this;
        var mouseMoveFunc = function (e) {
            var rect = _this.canvas.getBoundingClientRect();
            var rectContainer = _this.colorPalette.getBoundingClientRect();
            var offsetY = rect.top - rectContainer.top;
            var offsetX = rect.left - rectContainer.left;
            var width = _this.canvas.offsetWidth + offsetX;
            var height = _this.canvas.offsetHeight;
            var x = e.clientX - rect.left + offsetX;
            var y = e.clientY - rect.top + offsetY;
            x = x <= offsetX ? offsetX : (x >= width ? width - 1 : x);
            y = y <= offsetY ? offsetY : (y >= height + offsetY ? height + offsetY : y);
            _this.colorPointer.style.left = x - _this.getDimensions(_this.colorPointer).width / 2 + "px";
            _this.colorPointer.style.top = y - _this.getDimensions(_this.colorPointer).height / 2 + "px";
            var col = new Hsv(_this.hue, Math.round(x / width * 100), Math.round(100 - (y - offsetY) / height * 100));
            var b1w = ColorUtilities.hsv2rgb(col.$, col.s, col.v);
            _this.color = _this.formatColorString(ColorUtilities.rgbToHex(b1w.r, b1w.g, b1w.b));
        };
        var mouseUpFunc = function (e) {
            document.removeEventListener("mousemove", mouseMoveFunc);
        };
        var mouseDownFunc = function (e) {
            var rect = _this.canvas.getBoundingClientRect();
            var rectContainer = _this.colorPalette.getBoundingClientRect();
            var offsetY = rect.top - rectContainer.top;
            var offsetX = rect.left - rectContainer.left;
            var width = _this.canvas.offsetWidth + offsetX;
            var height = _this.canvas.offsetHeight;
            var x = e.clientX - rect.left + offsetX;
            var y = e.clientY - rect.top + offsetY;
            x = x <= offsetX ? offsetX : (x >= width ? width - 1 : x);
            y = y <= offsetY ? offsetY : (y >= height + offsetY ? height + offsetY : y);
            _this.colorPointer.style.left = x - _this.getDimensions(_this.colorPointer).width / 2 + "px";
            _this.colorPointer.style.top = y - _this.getDimensions(_this.colorPointer).height / 2 + "px";
            var col = new Hsv(_this.hue, Math.round(x / width * 100), Math.round(100 - (y - offsetY) / height * 100));
            var b1w = ColorUtilities.hsv2rgb(col.$, col.s, col.v);
            _this.color = _this.formatColorString(ColorUtilities.rgbToHex(b1w.r, b1w.g, b1w.b));
            document.addEventListener("mousemove", mouseMoveFunc);
        };
        this.canvas.addEventListener("mousedown", mouseDownFunc);
        this.colorPointer.addEventListener("mousedown", mouseDownFunc);
        document.addEventListener("mouseup", mouseUpFunc);
    };
    ColorPicker.prototype.sliderValueChanged = function ($event) {
        this.hue = $event.detail.value;
        this.drawColorPalette(this.hue);
    };
    ColorPicker.prototype.drawColorPalette = function (hue) {
        if (this.canvas !== null) {
            this.context2d = this.canvas.getContext("2d");
            this.context2dBuffer = this.bufferCanvas.getContext("2d");
            this.context2dBuffer.globalCompositeOperation = "source-over";
            this.context2d.globalCompositeOperation = "source-over";
            var b = this.canvas.width;
            var c = this.canvas.height;
            var d = this.context2d.createLinearGradient(0, c, 0, 0);
            d.addColorStop(0, "#000");
            d.addColorStop(1, "#FFF");
            this.context2d.fillStyle = d;
            this.context2d.fillRect(0, 0, b, c);
            d = this.context2dBuffer.createLinearGradient(b, 0, 0, 0);
            d.addColorStop(0, "hsl(" + hue + ",100%,50%)");
            d.addColorStop(1, "#FFF");
            this.context2dBuffer.fillStyle = d;
            this.context2dBuffer.fillRect(0, 0, b, c);
            var d1 = this.context2d.getImageData(0, 0, b, c);
            var e1 = d1.data;
            var b1 = this.context2dBuffer.getImageData(0, 0, b, c).data;
            var c1 = 0;
            var f1 = e1.length;
            for (; c1 < f1; c1 += 4) {
                e1[c1] = b1[c1] * e1[c1] / 255;
                e1[c1 + 1] = b1[c1 + 1] * e1[c1 + 1] / 255;
                e1[c1 + 2] = b1[c1 + 2] * e1[c1 + 2] / 255;
                e1[c1 + 3] = this.a;
            }
            this.context2d.putImageData(d1, 0, 0);
            var rect = this.canvas.getBoundingClientRect();
            var rectContainer = this.colorPalette.getBoundingClientRect();
            var rectPointer = this.colorPointer.getBoundingClientRect();
            var offsetY = rect.top - rectContainer.top;
            var offsetX = rect.left - rectContainer.left;
            var width = this.canvas.offsetWidth;
            var height = this.canvas.offsetHeight;
            if (width > 0 && height > 0) {
                var x = rectPointer.left + this.getDimensions(this.colorPointer).width / 2 - rect.left + offsetX;
                var y = rectPointer.top + this.getDimensions(this.colorPointer).height / 2 - rect.top + offsetY;
                x = x <= offsetX ? offsetX : (x >= width ? width : x);
                y = y <= offsetY ? offsetY : (y >= height + offsetY ? height + offsetY : y);
                this.colorPointer.style.left = x - this.getDimensions(this.colorPointer).width / 2 + "px";
                this.colorPointer.style.top = y - this.getDimensions(this.colorPointer).height / 2 + "px";
                var hsv = new Hsv(this.hue, Math.round(x / width * 100), Math.round(100 - (y - offsetY) / height * 100));
                var rgb = ColorUtilities.hsv2rgb(hsv.$, hsv.s, hsv.v);
                var rgbCurrentColor = ColorUtilities.getRgbColor(this.hexColorFormat);
                var hsvCurrentColor = ColorUtilities.rgbToHsv(rgbCurrentColor.r, rgbCurrentColor.g, rgbCurrentColor.b);
                if (hsvCurrentColor.h !== hsv.$ || hsvCurrentColor.s !== hsv.s || hsvCurrentColor.v !== hsv.v) {
                    this.color = this.formatColorString(ColorUtilities.rgbToHex(rgb.r, rgb.g, rgb.b));
                }
            }
        }
    };
    Object.defineProperty(ColorPicker.prototype, "colorText", {
        get: function () {
            if (this.hexColorFormat) {
                var rgb = ColorUtilities.getRgbColor(this.hexColorFormat);
                var o = Math.round(((rgb.r * 299) + (rgb.g * 587) + (rgb.b * 114)) / 1000);
                if (o > 125) {
                    return "black";
                }
                else {
                    return "white";
                }
            }
            return "grey";
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ColorPicker.prototype, "identifier", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ColorPicker.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ColorPicker.prototype, "format", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ColorPicker.prototype, "color", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.color; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ColorPicker.prototype, "hexColorFormat", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.color; })),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ColorPicker.prototype, "colorText", null);
    ColorPicker = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [])
    ], ColorPicker);
    return ColorPicker;
}());
export { ColorPicker };
